export function getFrom({from, to, min}) {
  let localFrom = parseInt(from);
  let localTo = parseInt(to);

  if (isNaN(localFrom)) {
    localFrom = min;
  }

  if ( localFrom < 0 )  {
    localFrom = 0;
  }

  if ( localFrom > localTo )  {
    localFrom = localTo ;
  }

  return localFrom;
}

export function getTo({from, to, max}) {
  const localFrom = parseInt(from);
  let localTo = parseInt(to);

  if (isNaN(localTo)) {
    localTo = max;
  }

  if ( localTo > max )  {
    localTo = max;
  }

  if ( localTo < localFrom  )  {
    localTo = localFrom;
  }

  return localTo;
}
